import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function CorporateTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug p-8 font-serif" data-testid="resume-live-preview">
      <div className="text-center pb-3" style={{ borderBottom: `3px solid ${accent}` }}>
        <h1 className="text-2xl font-bold uppercase tracking-[0.15em]" style={{ color: accent }}>{draft.full_name || "Your Name"}</h1>
        {draft.target_role && <p className="text-slate-600 text-xs mt-1 uppercase tracking-wider">{draft.target_role}</p>}
        <p className="text-slate-500 text-[11px] mt-1">{[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).join(" | ")}</p>
      </div>

      {draft.summary && (
        <div className="mt-4 text-center">
          <p className="text-slate-700 italic">{draft.summary}</p>
        </div>
      )}
      {draft.skills.length > 0 && (
        <div className="mt-4">
          <h2 className="text-xs font-bold uppercase tracking-[0.15em] text-center" style={{ color: accent }}>Core Competencies</h2>
          <p className="text-slate-700 mt-1.5 text-center">{draft.skills.join("  ·  ")}</p>
        </div>
      )}
      {draft.experience.length > 0 && (
        <div className="mt-5">
          <h2 className="text-xs font-bold uppercase tracking-[0.15em] border-b pb-1" style={{ color: accent, borderColor: `${accent}50` }}>Professional Experience</h2>
          {draft.experience.map((e, i) => (
            <div key={i} className="mt-2.5">
              <div className="flex items-baseline justify-between flex-wrap gap-1">
                <p className="font-bold text-slate-800">{e.title}, {e.company}</p>
                <p className="text-slate-400 font-normal italic text-[11px]">{dateRange(e.start_date, e.end_date, e.current)}</p>
              </div>
              <ul className="list-disc list-inside text-slate-700 mt-1">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
            </div>
          ))}
        </div>
      )}
      {draft.education.length > 0 && (
        <div className="mt-5">
          <h2 className="text-xs font-bold uppercase tracking-[0.15em] border-b pb-1" style={{ color: accent, borderColor: `${accent}50` }}>Education</h2>
          {draft.education.map((ed, i) => (
            <p key={i} className="text-slate-700 mt-1.5"><span className="font-bold text-slate-800">{ed.degree} {ed.field}</span> — {ed.school} <span className="text-slate-400 italic">({ed.start_date} - {ed.end_date})</span></p>
          ))}
        </div>
      )}
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
